import { observer } from 'mobx-react-lite'
import React from 'react'
import NonMediaAction from './NonMediaAction'

export default observer(function NonMediaActions({ actions, campaignScenario, actionGroup, }) {

  return (
    <div className="p-4 overflow-x-auto">
      <table className="border border-border-primary dark:border-rb-dark-mode-lighter">
        <thead>
          <tr className="bg-gray-200 dark:bg-rb-dark-mode-lighter">
            <td className="py-3 px-1 text-xs min-w-[150px] dark:text-white"></td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Inf. Pay Out Price</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[80px] dark:text-white">Inf. Price</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[70px] dark:text-white">KSA Tax</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[70px] dark:text-white">KSA Tax</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Advertiser Price include KSA</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Inf. Margin (%)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Inf. Margin Total</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Adv. Margin (%)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Adv. Margin Total</td>
          </tr>
        </thead>
        <tbody>
          { actions.map(action => <NonMediaAction key={action.id} action={action} campaignScenario={campaignScenario} />)}
        </tbody>
      </table>
    </div>
  )
})